// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-68428107] legend.h4{display:inline-block}[data-v-68428107] h1.color-failure,[data-v-68428107] h1.color-success{color:#000}[data-v-68428107] button,[data-v-68428107] button div{color:#000!important}[data-v-68428107] button.primary{color:#fff!important}[data-v-68428107] button:disabled{color:#666!important}", ""]);
// Exports
module.exports = exports;
